var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 13C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11L20 11C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13L3 13Z",
    fill: "#FFF7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2929 6.70711C12.9024 6.31658 12.9024 5.68342 13.2929 5.29289C13.6834 4.90237 14.3166 4.90237 14.7071 5.29289L20.7071 11.2929C21.0857 11.6715 21.0989 12.2811 20.7372 12.6757L15.2372 18.6757C14.864 19.0828 14.2314 19.1103 13.8243 18.7372C13.4172 18.364 13.3897 17.7314 13.7628 17.3243L18.6159 12.0301L13.2929 6.70711Z",
    fill: "#FFF7EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.521f9987ddc98282a769a9c4a0bfd5a2.svg";
export { ForwardRef as ReactComponent };